import React, { createContext, useContext, useMemo } from 'react';
import NativeCapability from '~/constants/common/nativeCapability';
import getSourcedSendMessageToNative from '~/native/common/dispatchers/getSourcedSendMessageToNative';

export type ContextType = {
  capabilities: Record<string, boolean>;
  source: 'home' | 'srp' | 'unknown' | 'vdp';
};

const defaultContext: ContextType = {
  capabilities: {},
  source: 'unknown'
};

const NativeContext = createContext<ContextType>(defaultContext);

export type OwnProps = ContextType;

export function NativeContextProvider({
  children,
  ...value
}: React.PropsWithChildren<OwnProps>) {
  return (
    <NativeContext.Provider value={value}>{children}</NativeContext.Provider>
  );
}

NativeContextProvider.displayName = 'NativeContextProvider';

export default NativeContext;

export function useNativeSource() {
  return useContext(NativeContext).source;
}

export function useIsNativeCapabilityActive(
  feature: keyof typeof NativeCapability
) {
  const { capabilities } = useContext(NativeContext);

  return capabilities[feature] ?? false;
}

export function useSendMessageToNative<Event>() {
  const nativeSource = useNativeSource();

  return useMemo(
    () => getSourcedSendMessageToNative<Event>(nativeSource),
    [nativeSource]
  );
}
